<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on: dialog }">
      <v-btn v-on="{ ...dialog }" v-bind="$attrs">
        <slot name="button">
            <v-icon small>mdi-trash-can-outline</v-icon>
        </slot>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="text-h5">
          {{ $t('feedbacks.deleteTalkDate') }}
        </span>
      </v-card-title>
      <v-card-text>
        {{ $t('feedbacks.deleteTalkDateConfirm') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          <slot name="close-button">{{ $t('close') }}</slot>
        </v-btn>

        <v-btn color="blue darken-1" text @click="confirm">
          <slot name="confirm-button">{{ $t('delete') }}</slot>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    processId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    dialog: false
  }),

  methods: {
    ...mapActions('feedbacks', {
      deleteTalkDate: 'deleteTalkDate'
    }),

    close() {
      this.dialog = false;
    },

    async confirm() {
      await this.deleteTalkDate(this.processId);
      this.dialog = false;

      this.$emit('deleted');
    }
  }
}
</script>